import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Modal, Form, Select, Button, message, Popconfirm } from "antd";
import restaurantSchemaActions from "../../../redux/restaurantSchema/actions";
import CloseButton from "../../Common/CloseButton/CloseButton";

const { Option } = Select;

const { editReservationTable, deleteReservationTable } =
  restaurantSchemaActions;

const EditTableModal = ({
  openEditTableModal,
  setOpenEditTableModal,
  clickedTable,
  setClickedTable,
}) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const handleEditTable = () => {
    form.validateFields().then((values) => {
      let [shape, chairsCount] = values.shape.split("-");

      dispatch(
        editReservationTable({
          x: clickedTable[0].x,
          y: clickedTable[0].y,
          direction: values.direction,
          shape: parseInt(shape),
          seatsCount: parseInt(chairsCount),
          organizationId: parseInt(localStorage.getItem("organizationId")),
          touchSaleTableId: clickedTable[0].touchSaleTableId,
          regionId: clickedTable[0].regionId,
        })
      );

      setClickedTable([]);
      setOpenEditTableModal(false);
      message.success("Успешно запазени промени");
      form.resetFields();
    });
  };

  const handleDeleteTable = (e) => {
    dispatch(
      deleteReservationTable({
        organizationId: parseInt(localStorage.getItem("organizationId")),
        touchSaleTableId: clickedTable[0].touchSaleTableId,
        regionId: clickedTable[0].regionId,
      })
    );
    setOpenEditTableModal(false);
    message.success("Успешно изтриване на маса");
    form.resetFields();
  };

  const shape = [
    { name: "Кръгла маса + 2 стола", value: "1-2" },
    { name: "Кръгла маса + 4 стола", value: "1-4" },
    { name: "Кръгла маса + 8 стола", value: "1-8" },
    { name: "Квардатна маса + 1 стол", value: "2-1" },
    { name: "Квардатна маса + 2 стол", value: "2-2" },
    { name: "Квардатна маса + 3 стол", value: "2-3" },
    { name: "Квардатна маса + 4 стол", value: "2-4" },
    {
      name: "Правоъгълна маса + 6 стола",
      value: "3-6",
    },
    {
      name: "Правоъгълна маса + 8 стола",
      value: "3-8",
    },
    {
      name: "Правоъгълна маса + 10 стола",
      value: "3-10",
    },
  ];

  const directions = [
    { name: "0°", value: 0 },
    { name: "45°", value: 45 },
    { name: "90°", value: 90 },
    { name: "135°", value: 135 },
    { name: "180°", value: 180 },
    { name: "225°", value: 225 },
    { name: "270°", value: 270 },
    { name: "315°", value: 315 },
    { name: "360°", value: 360 },
  ];

  useEffect(() => {
    if (clickedTable && clickedTable.length !== 0) {
      form.setFieldsValue({
        shape: `${clickedTable[0]?.shape}-${clickedTable[0]?.seatsCount}`,
        direction: clickedTable[0]?.direction,
      });
    }
  }, [clickedTable, form]);

  return (
    <Modal
      closeIcon={<CloseButton />}
      title={`Промени Маса (${clickedTable?.[0]?.tableName || ""})`}
      open={openEditTableModal}
      onOk={handleEditTable}
      onCancel={() => {
        setOpenEditTableModal(false);
        setClickedTable([]);
        form.resetFields();
      }}
      footer={null}
      className="restaurant-scheme-table-modal"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="shape"
          label="Форма на масата"
          rules={[
            { required: true, message: "Моля изберете форма на масата." },
          ]}
        >
          <Select
            showSearch
            virtual={false}
            placeholder="Форма на масата"
            placement="topLeft"
            className="restaurant-scheme-table-modal-select ant-select-selection-search-input"
          >
            {shape.map((singleShape, index) => (
              <Option
                key={`${singleShape.value}-${index}`}
                value={singleShape.value}
                className="restaurant-scheme-table-modal-option"
              >
                {singleShape.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="direction"
          label="Градус на наклон на масата"
          rules={[
            { required: true, message: "Моля изберете наклон на масата." },
          ]}
        >
          <Select
            showSearch
            virtual={false}
            placeholder="Наклон на масата"
            placement="topLeft"
            className="restaurant-scheme-table-modal-select ant-select-selection-search-input"
          >
            {directions.map((direction, index) => (
              <Option
                key={`${direction.value}-${index}`}
                value={direction.value}
                className="restaurant-scheme-table-modal-option"
              >
                {direction.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
      <div className="restaurant-scheme-edit-table-modal-footer">
        <Popconfirm
          title="Изтриване на маса"
          description="Сигурни, че искате да изтриете тази маса?"
          onConfirm={handleDeleteTable}
          placement="bottom"
          okText="Изтрий"
          cancelText="Назад"
        >
          <Button danger>Изтрий маса</Button>
        </Popconfirm>
        <Button type="primary" onClick={handleEditTable}>
          Промени
        </Button>
      </div>
    </Modal>
  );
};

export default EditTableModal;
